import React from "react";
import PropTypes from "prop-types";
import { SFStack } from "../../../grid";
import SFIconButton from "../../../button/iconButton";
import SFTooltip from "../../../tooltip";
import getStyled from "../../../../hooks/getStyled";

const { styled } = getStyled();

const SFStackStyled = styled(SFStack, {
  shouldForwardProp: (prop) => prop !== "displaySvgIcons",
})(({ theme, displaySvgIcons }) => ({
  "& .MuiSvgIcon-root": {
    display: !displaySvgIcons ? "none" : "block",
  },
}));

const ActionButton = ({ icon, onClick }) => {
  return (
    <SFIconButton
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      {icon}
    </SFIconButton>
  );
};

ActionButton.propTypes = {
  icon: PropTypes.node,
  onClick: PropTypes.func,
};

const ActionButtonWithTooltip = ({ icon, onClick, tooltip }) => {
  return (
    <SFTooltip content={tooltip} placement="bottom">
      <span>
        <ActionButton icon={icon} onClick={onClick} />
      </span>
    </SFTooltip>
  );
};

ActionButtonWithTooltip.propTypes = {
  icon: PropTypes.node,
  onClick: PropTypes.func,
  tooltip: PropTypes.string,
};

const ActionButtons = ({ buttonDefs }) => {
  return (
    <SFStackStyled
      direction="row"
      alignItems="center"
      justifyContent="flex-end"
      spacing={0}
      displaySvgIcons={true}
    >
      {buttonDefs.length > 0 &&
        buttonDefs
          .filter((buttonDef) => !buttonDef.hide)
          .map((buttonDef, index) => {
            if (buttonDef.tooltip) {
              return (
                <ActionButtonWithTooltip
                  key={index}
                  icon={buttonDef.icon}
                  onClick={buttonDef.onClick}
                  tooltip={buttonDef.tooltip}
                />
              );
            } else {
              return (
                <ActionButton
                  key={index}
                  icon={buttonDef.icon}
                  onClick={buttonDef.onClick}
                />
              );
            }
          })}
    </SFStackStyled>
  );
};

ActionButtons.propTypes = {
  buttonDefs: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.node,
      onClick: PropTypes.func,
      tooltip: PropTypes.string,
      hide: PropTypes.bool,
    })
  ),
};

export default ActionButtons;
